import React, { useState } from "react";
import "./addCategoryDialog.scss";
const AddCategoryDialog = ({ handleAdding, handleClose, categoryLevel }) => {
  const isRootLevel = categoryLevel === 0;
  const [name, setName] = useState("");
  const [isFamily, setIsFamily] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  return (
    <div className="add-category-dialog-overlay">
      <div className="add-category-dialog-box" dir="rtl" lang="he">
        <span className="close-icon" onClick={() => handleClose(false)}>
          ×
        </span>
        <h2>הוסף מחלקה חדשה</h2>
        <p>הזן שם למחלקה החדשה שברצונך להוסיף.</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAdding(name, isRootLevel ? false : isFamily, showHeader);
          }}
        >
          <div className="details">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              dir="rtl"
              placeholder="שם"
            />
            <div className="checkboxes">
              <label className="family-checkbox">
                <input
                  className="checkbox"
                  type="checkbox"
                  checked={showHeader}
                  onChange={() => setShowHeader(!showHeader)}
                />
                <span>הצג שם קטגוריה</span>
              </label>
              {!isRootLevel && (
                <label className="family-checkbox">
                  <input
                    className="checkbox"
                    type="checkbox"
                    checked={isFamily}
                    onChange={() => setIsFamily(!isFamily)}
                  />
                  <span>מקבץ</span>
                </label>
              )}
            </div>
          </div>
          <button type="submit">הוסף</button>
        </form>
      </div>
    </div>
  );
};
export default AddCategoryDialog;
